document.addEventListener("DOMContentLoaded", () => {
  const isTouchDevice =
    window.matchMedia("(hover: none)").matches &&
    window.matchMedia("(pointer: coarse)").matches;
  if (isTouchDevice) {
    return;
  }

  const magnifiers = document.querySelectorAll(".magnifier");
  if (magnifiers.length === 0) {
    return;
  }

  const Z = 2.5;
  const GAP = 12;

  /** Rendered image box for an object-fit: cover image inside its container. */
  function coverBox(img, w, h) {
    const nw = img.naturalWidth || 1400;
    const nh = img.naturalHeight || 1750;
    const s = Math.max(w / nw, h / nh);
    const rw = nw * s;
    const rh = nh * s;
    return { rw, rh, ox: (w - rw) / 2, oy: (h - rh) / 2 };
  }

  for (const img of magnifiers) {
    const host = img.parentElement || img;
    if (getComputedStyle(host).position === "static") {
      host.style.position = "relative";
    }

    const lens = document.createElement("div");
    lens.className = "koleen-lens koleen-lens--line";
    lens.setAttribute("aria-hidden", "true");
    host.appendChild(lens);

    // The panel lives outside the card's clipped image wrapper, like the demo's
    // .side-panel is a sibling of .koleen-card inside .demo.
    const container = img.closest(".koleen-card") || host.parentElement || host;
    const panel = document.createElement("div");
    panel.className = "koleen-side-panel";
    panel.setAttribute("aria-hidden", "true");
    container.appendChild(panel);

    let geo = null;

    const layout = () => {
      const r = img.getBoundingClientRect();
      const W = r.width;
      const H = r.height;
      const lw = W / Z;
      const lh = H / Z;
      lens.style.width = lw + "px";
      lens.style.height = lh + "px";
      // Panel matches the image size; place right, else left, else overlay the image.
      const vw = document.documentElement.clientWidth;
      let left;
      if (r.right + GAP + W <= vw - 8) left = W + GAP;
      else if (r.left - GAP - W >= 8) left = -(W + GAP);
      else left = 0;
      const cr = container.getBoundingClientRect();
      Object.assign(panel.style, {
        width: W + "px",
        height: H + "px",
        left: r.left - cr.left + left + "px",
        top: r.top - cr.top + "px",
      });
      const src = img.dataset.large || img.getAttribute("src");
      const b = coverBox(img, W, H);
      panel.style.backgroundImage = `url(${src})`;
      panel.style.backgroundRepeat = "no-repeat";
      panel.style.backgroundSize = `${b.rw * Z}px ${b.rh * Z}px`;
      geo = { r, W, H, lw, lh, b };
    };

    const move = (e) => {
      // Re-measure every move: the page can shift under us (lazy images,
      // fonts) after the first hover, which would leave the lens offset.
      const r = img.getBoundingClientRect();
      const W = r.width;
      const H = r.height;
      const lw = W / Z;
      const lh = H / Z;
      const b = coverBox(img, W, H);
      // Clamp the lens so it never leaves the image bounds.
      const x = Math.min(W - lw, Math.max(0, e.clientX - r.left - lw / 2));
      const y = Math.min(H - lh, Math.max(0, e.clientY - r.top - lh / 2));
      lens.style.width = lw + "px";
      lens.style.height = lh + "px";
      lens.style.transform = `translate3d(${x}px, ${y}px, 0)`;
      panel.style.backgroundSize = `${b.rw * Z}px ${b.rh * Z}px`;
      panel.style.backgroundPosition = `${-(x - b.ox) * Z}px ${-(y - b.oy) * Z}px`;
    };

    img.addEventListener("pointerenter", (e) => {
      if (e.pointerType !== "mouse") return;
      layout();
      move(e);
      img.classList.add("is-zoom");
      host.classList.add("is-zoom");
      container.classList.add("is-zoom");
    });
    img.addEventListener("pointermove", (e) => {
      if (geo) move(e);
    });
    img.addEventListener("pointerleave", () => {
      geo = null;
      img.classList.remove("is-zoom");
      host.classList.remove("is-zoom");
      container.classList.remove("is-zoom");
    });
  }
});
